import { Box, Loader } from '@mantine/core'
import React from 'react'

const style = {
  display: 'flex',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center',
  marginTop: '40px'
}

const BigSpinning = () => (
  <Box style={style}>
    <Loader size="xl" />
  </Box>
)

export default BigSpinning
